import {css} from '@emotion/css';
import {useMemo} from 'react';

import {useWolfTheme} from '../../../../contexts';

const useStyles = () => {
    const theme = useWolfTheme();

    return useMemo(
        () => ({
            wrapper: css({
                '&': {
                    display: 'flex',
                    flexDirection: 'row',

                    '& li': {
                        display: 'flex',
                        alignItems: 'center',
                        paddingLeft: theme.orbitalFour,
                        paddingRight: theme.orbitalFour,

                        '& a': css({
                            color: theme.palette.foreground.default,
                            cursor: 'pointer',
                            textDecoration: 'none',
                        }),

                        '&:first-child': {
                            paddingLeft: 0,
                        },
                    },

                    '& > li:not(:last-child)': {
                        color: theme.palette.foreground.default,
                        borderRight: `1px solid ${theme.palette.foreground.default}`,
                    },
                },
            }),
        }),
        [theme]
    );
};

export default useStyles;
